import React, { useState, useEffect } from 'react';
import { Spin } from 'antd';
import RosterService from '../../services/roster-service';

const Person = ( props ) => {
    const { personId, auth } = props;

    const [ person, setPerson ] = useState( null );

    useEffect( () => {
        if ( !personId ) {
            return;
        }
        const loadPerson = async () => {
            try {
                const roster = RosterService( auth.state.original );
                const personResponse = await roster.getPerson( personId );
                setPerson( personResponse );
            } catch ( error ) {
                console.error( 'Error fetching person', error.status );
                setPerson( null );
            }
        };
        loadPerson();
    }, [ personId, auth?.state?.original?.claims?.company_id ] );

    return (
        person ?
            <span>{ person.givenName } { person.surname }</span>
            :
            <span style={ { display: 'flex' } } > <Spin size="small" data-testid="person-spin" /> </span>
    );
};

export default Person;